// extracted by mini-css-extract-plugin
export default {"LogTime":"Logs_LogTime__JgHTY","Log":"Logs_Log__7q9-B","ClearLogsBtn":"Logs_ClearLogsBtn__FLd-Y","LogsPopupOverlay":"Logs_LogsPopupOverlay__6nS6V"};